export default __webpack_public_path__ + "static/media/myr.bde71b04.png";